(function ($) {

    $.fn.numberstyle = function (options) {

        /*
         * Default settings
         */
        var settings = $.extend({
            value: 0,
            step: undefined,
            min: undefined,
            max: undefined
        }, options);

        /*
         * Init every element
         */
        return this.each(function (i) {

            /*
             * Base options
             */
            var input = $(this);

            /*
       * Add new DOM
       */
            var container = document.createElement('div'),
                btnAdd = document.createElement('div'),
                btnRem = document.createElement('div'),
                min = (settings.min) ? settings.min : input.attr('min'),
                max = (settings.max) ? settings.max : input.attr('max'),
                value = (settings.value) ? settings.value : parseFloat(input.val());
            container.className = 'numberstyle-qty';
            btnAdd.className = (max && value >= max) ? 'qty-btn qty-add disabled' : 'qty-btn qty-add';
            btnAdd.innerHTML = '+';
            btnRem.className = (min && value <= min) ? 'qty-btn qty-rem disabled' : 'qty-btn qty-rem';
            btnRem.innerHTML = '-';
            input.wrap(container);
            input.closest('.numberstyle-qty').prepend(btnRem).append(btnAdd);

            var getEachInputVal = this.value;

            /*
             * Attach events
             */
            // use .off() to prevent triggering twice
            $(document).off('click', '.qty-btn').on('click', '.qty-btn', function (e) {

                var input = $(this).siblings('input'),
                    sibBtn = $(this).siblings('.qty-btn'),
                    step = (settings.step) ? parseFloat(settings.step) : parseFloat(input.attr('step')),
                    min = (settings.min) ? settings.min : (input.attr('min')) ? input.attr('min') : undefined,
                    max = (settings.max) ? settings.max : (input.attr('max')) ? input.attr('max') : undefined,
                    oldValue = parseFloat(input.val()),
                    newVal;

                //Add value
                if ($(this).hasClass('qty-add')) {

                    newVal = (oldValue >= max) ? oldValue : oldValue + step;

                    newVal = (newVal > max) ? max : newVal;

                    if (newVal == max) {
                        $(this).addClass('disabled');
                    }
                    sibBtn.removeClass('disabled');

                    //Remove value
                } else {

                    //const step = oldValue > 100000 ? 50000 : 25000;
                    newVal = (oldValue <= min) ? oldValue : oldValue - step;
                    newVal = (newVal < min) ? min : newVal;

                    if (newVal == min) {
                        $(this).addClass('disabled');
                    }
                    sibBtn.removeClass('disabled');

                }

                //Update value
                input.val(newVal).trigger('change');

            });

            input.on('change', function () {

                //Get id of input on input change,
                var pricingCardId = this.id;

                // Match input Id to overall price of each plan
                switch (pricingCardId) {
                    case 'starterInput':
                        pricingcardPlan = 'starter';
                        break;
                    case 'proInput':
                        pricingcardPlan = 'pro';
                        break;
                    case 'enterpriseInput':
                        pricingcardPlan = 'enterprise';
                        break;
                }

                // Use class name of each pricing plan to get string value then parse into integer
                function getPricePlanName(insertPricePlanName) {
                    if (locale === 'us') {
                        //Get US prices
                        pricePlanName = $('.us--' + insertPricePlanName);
                    } else {
                        // Get UK prices
                        pricePlanName = $('.uk--' + insertPricePlanName);
                    }
                }

                getPricePlanName(pricingcardPlan);

                // Get value of input on click
                pricingInputs = parseFloat(input.val());
                // Calc
                additionalEmailsCredits = pricingInputs - getEachInputVal;
                // Use look up table
                pricingCalc = pricingLookupTable[additionalEmailsCredits];
                // Check what switch is set to!
                pricingSwitch = $('#pricingToggle');

                if (pricingSwitch.hasClass('active')) {
                    // monthly

                    // Get the price from html data attribute and parse,
                    // add lookup to monthly price add into html
                    pricePlanMonthlyTotal = pricePlanName.data('monthly-total');
                    parsepricePlanMonthlyTotal = parseInt(pricePlanMonthlyTotal);
                    //Calculate 10% of lookup table value and add on to overall figure
                    //var getTenPercent = Math.round((pricingCalc / 10));
                    //var addTenPercent = (getTenPercent + pricingCalc);
                    var monthlyCalcPrice = (parsepricePlanMonthlyTotal + pricingCalc);
                    // Add monthlyCalcPrice into HTML
                    pricePlanName.html(monthlyCalcPrice);

                } else {
                    // annual
                    // Get the price from html data attribute for UK/US and parse,
                    // add lookup to UK/US annual price and into html
                    pricePlanAnnualTotal = pricePlanName.data('annual-total');
                    parsepricePlanAnnualTotal = parseInt(pricePlanAnnualTotal);
                    var annualCalcPrice = (parsepricePlanAnnualTotal + pricingCalc);
                    // Add annualCalcPrice into HTML
                    pricePlanName.html(annualCalcPrice);
                }

            });

        });
    };

    /*
     * Init
     */

    $('.numberstyle').numberstyle();

}(jQuery));


// Change step on Enterprise Quantity Input Only
var enterpriseInput = $('#enterpriseInput');
var enterpriseCard = $("#enterpriseCard");
var enterpriseBtns = enterpriseCard.find('.qty-btn');

enterpriseBtns.off('click').on('click', function (e) {

    var parseEnterpriseVal = (parseInt(enterpriseInput.val()));
    max = (enterpriseInput.attr('max'));
    min = (enterpriseInput.attr('min'));
    oldValue = parseFloat(enterpriseInput.val());

    if (parseEnterpriseVal > 100000) {
        stepMinus = 50000;
        stepPlus = 50000;
    } else if (parseEnterpriseVal == 100000) {
        stepMinus = 25000;
        stepPlus = 50000;
    } else {
        stepMinus = 25000;
        stepPlus = 25000
    }

    enterpriseInput.attr('stepPlus', stepPlus);
    enterpriseInput.attr('stepMinus', stepMinus);

    //Add value
    if ($(this).hasClass('qty-add')) {
        newVal = (oldValue >= max) ? oldValue : oldValue + stepPlus;
        newVal = (newVal > max) ? max : newVal;
    } else {
        newVal = (oldValue <= min) ? oldValue : oldValue - stepMinus;
        newVal = (newVal < min) ? min : newVal;
    }

    //Update value
    enterpriseInput.val(newVal);
});

// disable plus/minus buttons on the data plan input

var dataCard = $("#dataCard");
var dataBtns = dataCard.find('.qty-btn');

dataBtns.addClass('disabled');
dataBtns.on("click", function () {
    return false;
}); //this works.